import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import Balise from '../Entity/Balise'

/**
* Class BaliseList
* BaliseList view component
**/
class BaliseList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = Balise;

    // Filter list
    const filters = [{
      title: "Nom de la balise",
      type: "text",
      name: "nom",
      rowIdx: 1
    }];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes systèmes de mesure</h2>
        <GridFilter title="Filtrer les systèmes de mesure" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />

        <Button bsStyle="success" className="btnGraphique" onClick={this.openGraphique.bind(this)}>Afficher données graphique</Button>
        <h2></h2>

        <Grid title="Systèmes de mesure" ref="gridBalise" path="balises" objectPath="balises" objectClass={objectClass} height="400px" hidden={false} />
        
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["gridBalise"];
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs["gridBalise"];
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["gridBalise"];
    grid.clearFilters();
  }


  openGraphique() {
    var urlLocal='http://localhost:8082/graphique/';
    var urlServer='http://canna/graphique/';
    var win = window.open(urlServer, '_blank');
      //win.focus();

  }

}
export default BaliseList;



// WEBPACK FOOTER //
// ./src/views/Search/BaliseList.js